import { PartnerConfig } from "src/app/core/interfaces/partner-config";

export const Partner: PartnerConfig = {
  id: 'dev',
  title: {
    de: 'Sysbiz Development Portal [de]',
    it: 'Sysbiz Development Portal [it]',
    en: 'Sysbiz Development Portal [en]'
  },
  portalUrl: 'https://dev-bs.systems.bz',
  apiUrl: 'https://dev-bs.systems.bz',
  oldPortalUrl: 'https://dev-bs.systems.bz/-/',
  jobServiceUrl: 'https://dev-job.systems.bz/jobs',
  backlink: true,
  bankingVersionCookie: { name: 'dev-portal-version-banking', domain: '.systems.bz' },
  documentSignerVersionCookie: { name: 'dev-portal-version-documentsigner', domain: '.systems.bz' },
  postboxVersionCookie: { name: 'dev-portal-version-postbox', domain: '.systems.bz' },
  conservationVersionCookie: { name: 'dev-portal-version-conservation', domain: '.systems.bz' },
  ssoRedirectPage: "https://dev-sso.systems.bz/8fc7a4ac-8434-f011-a5f1-6045bd9b7d9c",
}

